import moment from 'moment';
import Uuid from '../../../../support/Uuid';

class PlataformasTecnologicasResponseInputPipe {
  getName() {
    return 'plataformas-tecnologicas';
  }

  apply(data) {
    const { Complemento = {} } = data;

    if (!Complemento.ServiciosPlataformasTecnologicas) {
      return data;
    }

    const ServiciosPlataformasTecnologicas = { ...Complemento.ServiciosPlataformasTecnologicas };

    const { Servicios = {} } = ServiciosPlataformasTecnologicas;

    data.Complemento = {
      ...data.Complemento,
      ServiciosPlataformasTecnologicas: {
        ...ServiciosPlataformasTecnologicas,
        Servicios: {
          ...Servicios,
          DetallesDelServicio: Servicios.DetallesDelServicio.map((item) => {
            return {
              ...item,
              id: Uuid.v4(),
              FechaServ: moment(item.FechaServ).toDate(),
            };
          }),
        },
      },
    };

    return data;
  }
}

export default PlataformasTecnologicasResponseInputPipe;
